import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  addPatientToRegion2,
  getPatients,
  putAddPatient,
} from "../../../../api/area";
import { updatePatient } from "../../../../api/group";
import FemaleIcon from "../../../../assets/SVG/femaleIcon";
import MaleIcon from "../../../../assets/SVG/maleIcon";
import InputLoginForm from "../../../login/inputLoginForm";
import CustomizedHook from "../../../project/autocomplatePro";
import { InputCreateProject } from "../../../project/createProjectPop";
import DatePicker from "../../../project/datePicker";
import moment from "jalali-moment";

export default function FormReception({
  mode,
  dataArea,
  ageType,
  DATA,
  handleClose,
  nationalId,
  setDataPatients,
  setLevelPop,
  setSelectedLevel,
  edit,
}) {
  const [data, setData] = useState({
    name: "",
    fatherName: "",
    sex: "MALE",
    birthDate: "",
    phone: "",
    identifier: "",
    identifierType: "NATIONAL_CODE",
    insurance: "TAMIN",
    ageType: ageType,
    // job: "",
  });
  // console.log(ageType);
  const [showDatePicker, setShowDatePicker] = useState();
  const [date, setDate] = useState();
  useEffect(() => {
    if (date && !edit && !DATA) {
      setData({ ...data, birthDate: date?.toUnix() * 1000 });
    }
    if (date && edit) {
      const timestamp = moment
        .from(`${date?.year}/${date?.month}/${date?.day}`, "fa", "YYYY/MM/DD")
        .valueOf();
      setData({ ...data, birthDate: timestamp });
    }
  }, [date]);
  useEffect(() => {
    if (mode) {
      setData({
        ...data,
        identifierType: mode === "irani" ? "NATIONAL_CODE" : "SRG",
      });
    }
  }, [mode]);
  useEffect(() => {
    if (ageType === "ADULT") {
      setData({
        name: "",
        fatherName: "",
        sex: "MALE",
        birthDate: "",
        phone: "",
        identifier: "",
        identifierType: "NATIONAL_CODE",
        insurance: "TAMIN",
        ageType: "ADULT",
        job: "",
        patientNo: "",
      });
    }
    if (ageType === "CHILD") {
      setData({
        name: "",
        fatherName: "",
        sex: "MALE",
        birthDate: "",
        phone: "",
        identifier: "",
        identifierType: "NATIONAL_CODE",
        insurance: "TAMIN",
        ageType: "CHILD",
        patientNo: "",
      });
    }
  }, [ageType]);

  useEffect(() => {
    if (nationalId) {
      setData({ ...data, identifier: nationalId });
    }
  }, [nationalId]);

  useEffect(() => {
    if (DATA) {
      setData(DATA);
      const datePart = DATA.birthDate?.split(" - ")[0];

      // تجزیه سال، ماه و روز
      const [year, month, day] = datePart.split("/");

      // ساختن آرایه‌ای با دو آبجکت
      const dateDef = { year: year, month: month, day: day };
      setDate(dateDef);
    }
  }, [DATA]);

  return (
    <Box
      mt="30px"
      gap="20px"
      justifyContent={"space-around"}
      display="flex"
      flexWrap={"wrap"}
    >
      <DatePicker
        sx={{ marginLeft: "-30px !important" }}
        notRange
        date={date}
        setDate={setDate}
        show={showDatePicker}
        setShow={setShowDatePicker}
      />
      <Box>
        <Typography
          sx={{
            color: "#000",
            fontSize: "13px",
            fontStyle: "normal",
            fontWeight: "bold",
            lineHeight: "18px",
            // mb: "5px",
          }}
        >
          {"جنسیت / نام و نام خانوادگی"}
        </Typography>

        <Box width="fit-content" alignItems={"end"} gap="1px" display="flex">
          <Box
            border="solid 1px #d0d0d0"
            px="5px"
            bgcolor={"#f3f3f3"}
            borderRadius={"8px"}
            height="35px"
            sx={{ cursor: "pointer" }}
            onClick={() => {
              if (data?.sex === "MALE") {
                setData({ ...data, sex: "FEMALE" });
              } else {
                setData({ ...data, sex: "MALE" });
              }
            }}
          >
            {data?.sex === "MALE" ? (
              <MaleIcon size={"0.7"} />
            ) : (
              <FemaleIcon size={"0.7"} />
            )}
          </Box>
          <InputCreateProject
            width="185px"
            placeholder={"نام و نام خانوادگی بیمار را وارد کنید. "}
            // label="جنسیت / نام و نام خانوادگی"
            value={data.name}
            onChange={(e) => setData({ ...data, name: e.target.value })}
          />
        </Box>
      </Box>
      <InputCreateProject
        placeholder={"نام پدر بیمار را وارد کنید."}
        label="نام پدر"
        value={data.fatherName}
        onChange={(e) => setData({ ...data, fatherName: e.target.value })}
      />
      <InputCreateProject
        placeholder={"تاریخ تولد بیمار را انتخاب کنید."}
        label="تاریخ تولد"
        onClick={(e) => {
          setShowDatePicker(e.currentTarget);
        }}
        value={
          date
            ? `${date?.year}/${date?.month}/${date?.day}`
            : data?.birthDate
            ? data?.birthDate
            : ""
          // :`${date.year}`
        }
        onChange={(e) => {
          if (!date) {
            setData({ ...data, birthDate: e.target.value });
          }
        }}
      />
      <InputCreateProject
        placeholder={"شماره تلفن همراه والدین/ثابت بیمار را وارد کنید."}
        label={ageType === "ADULT" ? "شماره تلفن" : "شماره تلفن والدین"}
        value={data.phone}
        onChange={(e) => setData({ ...data, phone: e.target.value })}
        inputProps={{ maxLength: 11 }}
      />
      <InputCreateProject
        placeholder={
          mode === "irani"
            ? "کد ملی بیمار را به صورت کامل وارد کنید."
            : "کد اتباع بیمار را به صورت کامل وارد کنید."
        }
        label={mode === "irani" ? "کد ملی" : "کد اتباع"}
        value={data.identifier}
        onChange={(e) => setData({ ...data, identifier: e.target.value })}
      />
      <Box width="45%">
        <CustomizedHook
          multiple
          placeholder={"انتخاب کنید"}
          label="نوع بیمه"
          options={[
            { name: "تکمیلی", value: "TAKMIL" },
            { name: "نیروهای مسلح", value: "MILITARY" },
            { name: "تامین اجتماعی", value: "TAMIN" },
            { name: "سلامت", value: "SALAMAT" },
            { name: "ندارد", value: "NONE" },
          ]}
          onChange={(event, newValue) => {
            setData({ ...data, insurance: newValue.value });
          }}
          value={
            [
              { name: "تکمیلی", value: "TAKMIL" },
              { name: "نیروهای مسلح", value: "MILITARY" },
              { name: "تامین اجتماعی", value: "TAMIN" },
              { name: "سلامت", value: "SALAMAT" },
              { name: "ندارد", value: "NONE" },
            ]?.find((x) => x.value === data?.insurance) || null
          }
        />
      </Box>
      {ageType === "ADULT" && (
        <InputCreateProject
          placeholder={"شغل بیمار را به صورت کامل وارد کنید."}
          label="شغل"
          value={data.job}
          onChange={(e) => setData({ ...data, job: e.target.value })}
        />
      )}
      <InputCreateProject
        onChange={(e) => setData({ ...data, patientNo: e.target.value })}
        value={data?.patientNo}
        placeholder={"شماره پرونده بیمار را  وارد کنید."}
        label="شماره پرونده"
      />
      <button
        onClick={() => {
          if (edit) {
            if (data && dataArea) {
              updatePatient(data.id, dataArea[0]?.areas[0]?.id, data)
                .then(() => {
                  getPatients(dataArea[0]?.areas[0]?.id)
                    .then((x) => {
                      setDataPatients(x);
                    })
                    .catch(() => {});
                  handleClose();
                })
                .catch(() => {});
            }
          } else {
            if (data && dataArea) {
              if (DATA) {
                addPatientToRegion2(dataArea[0]?.areas[0]?.id, data?.id)
                  .then(() => {
                    setLevelPop(0);
                    setData({
                      name: "",
                      fatherName: "",
                      sex: "MALE",
                      birthDate: "",
                      phone: "",
                      identifier: "",
                      identifierType: "NATIONAL_CODE",
                      insurance: "TAMIN",
                      ageType: ageType,
                    });
                    setSelectedLevel();
                    getPatients(dataArea[0]?.areas[0]?.id)
                      .then((x) => {
                        setDataPatients(x);
                      })
                      .catch(() => {});
                    handleClose();
                  })
                  .catch(() => {
                    handleClose();
                    setData({
                      name: "",
                      fatherName: "",
                      sex: "MALE",
                      birthDate: "",
                      phone: "",
                      identifier: "",
                      identifierType: "NATIONAL_CODE",
                      insurance: "TAMIN",
                      ageType: ageType,
                    });
                    setLevelPop(0);
                    setSelectedLevel();
                  });
              } else {
                putAddPatient(dataArea[0]?.areas[0]?.id, data)
                  .then(() => {
                    setLevelPop(0);
                    setData({
                      name: "",
                      fatherName: "",
                      sex: "MALE",
                      birthDate: "",
                      phone: "",
                      identifier: "",
                      identifierType: "NATIONAL_CODE",
                      insurance: "TAMIN",
                      ageType: ageType,
                    });
                    setSelectedLevel();
                    getPatients(dataArea[0]?.areas[0]?.id)
                      .then((x) => {
                        setDataPatients(x);
                      })
                      .catch(() => {});
                    handleClose();
                    setData({
                      name: "",
                      fatherName: "",
                      sex: "MALE",
                      birthDate: "",
                      phone: "",
                      identifier: "",
                      identifierType: "NATIONAL_CODE",
                      insurance: "TAMIN",
                      ageType: ageType,
                    });
                    setLevelPop(0);
                    setSelectedLevel();
                  })
                  .catch(() => {});
              }
            }
            // setLevel(2)
          }
        }}
        // style={
        //   date?.length >= 2 && countTrip && tripName
        //     ? {}
        //     : { opacity: "0.5", cursor: "no-drop" }
        // }
        className="btnCreate"
      >
        {"ایجاد بیمار"}
      </button>
    </Box>
  );
}
